package top.wcpe.allincore.ui.runtime.element

import top.wcpe.allincore.layout.engine.LayoutMode
import kotlin.jvm.JvmStatic

/**
 * 列容器：子元素垂直排列。
 */
class Column private constructor() : UIElement<Column>() {

    init {
        styleField.layout().mode = LayoutMode.COLUMN
    }

    protected override fun self(): Column = this

    companion object {
        @JvmStatic
        fun create(): Column = Column()
    }
}
